import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'patientNumberPad'
})
export class PatientNumberPadPipe implements PipeTransform {
  transform(value: any): string {
    if (!value) {
      return value.toString();
    }
    return value.toString().padStart(4, '0');
  }

}
